 /*================ Overview Table Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('overviewTableFactory', overviewTableFactory);

    overviewTableFactory.$inject = ['$http','$log', 'vppConfig', 'ProgramInfoService'];

    function overviewTableFactory($http, $log, vppConfig, ProgramInfoService){
      return function(){
        var programCode = ProgramInfoService.getProgramCode().toLowerCase();
        var Url = vppConfig.overviewTablePath + "table-" + programCode +".json";
        var promise = $http.get(Url).then(function(data){
        return data;
      }, function errorCallback (data){
        return data;
      })

      return promise;
      }
      
  };